import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { slugify } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const DynamicFormattedMessage = FormattedMessage;

const SubCategoryTreeList = styled.ul`
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  padding-left: 16px;
  list-style: none;
`;

const SubCategoryTreeItemLink = styled.a`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

const SubCategoryTreeItemLinkText = styled.p`
  padding: 19px 32px 19px 24px;
`;

// This is a recursive component that renders a tree of subcategories,
// working with the MobileGridCategoryTreeDropdown component
const MobileGridSubcategoryTree = ({ subcategories = [] }) => {
  if (!subcategories?.length) {
    return null;
  }

  return (
    <SubCategoryTreeList>
      {subcategories.map((subcategory) => (
        <li key={subcategory?.urlPath} data-autotag="grid-category-dd-option">
          <SubCategoryTreeItemLink href={subcategory?.urlPath}>
            <SubCategoryTreeItemLinkText>
              <DynamicFormattedMessage
                id={`site_product_category.${slugify(subcategory.label)}`}
                defaultMessage={subcategory.label}
              />
            </SubCategoryTreeItemLinkText>
          </SubCategoryTreeItemLink>
          <MobileGridSubcategoryTree
            subcategories={subcategory?.subcategories}
          />
        </li>
      ))}
    </SubCategoryTreeList>
  );
};

MobileGridSubcategoryTree.propTypes = {
  subcategories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      urlPath: PropTypes.string,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          urlPath: PropTypes.string,
        })
      ),
    })
  ),
};
export default MobileGridSubcategoryTree;
